import { defineStore } from 'pinia'
import ApiService from '@common/services/api.service'
import JwtService from '@common/services/jwt.service'


export const useAuthStore = defineStore('auth', {
  state: () => ({
    authToken: JwtService.getToken(),
    refreshToken: JwtService.getRefreshToken() ? JwtService.getRefreshToken() : null,
    utilisateur: JSON.parse(localStorage.getItem('utilisateur')) || null,
    permissions: (() => { const p = JSON.parse(localStorage.getItem('permissions')); return Array.isArray(p) ? p : []; })() as string[],
    afficherErreurConnexion: false
  }),
  actions: {

    async fetchUtilisateur() {
      try {
        const responseUtilisateur = await ApiService.get('/auth/utilisateur')
        this.utilisateur = responseUtilisateur.data
        localStorage.setItem('utilisateur', JSON.stringify(this.utilisateur))
      } catch (error) {
        this.utilisateur = null
        localStorage.removeItem('utilisateur')
      }

    },

    async fetchPermissions() {
      try {
        const response = await ApiService.get('/auth/utilisateur/permissions')
        this.permissions = Array.isArray(response.data) ? response.data : []
        localStorage.setItem('permissions', JSON.stringify(this.permissions))
      } catch (error) {
        this.permissions = null
        localStorage.removeItem('permissions')
      }


    },

    async authentifier(methodeAuthentificationId: string, payload: object) {
      try {
        const responseJeton = await ApiService.post<{
          token: string;
          refresh_token: string;
        }>('/auth/' + methodeAuthentificationId + '/jeton', payload)

        JwtService.saveToken(responseJeton.data.token, responseJeton.data.refresh_token)
        this.authToken = responseJeton.data.token
        this.refreshToken = responseJeton.data.refresh_token

        this.authToken = JwtService.getToken()


        await this.fetchUtilisateur()

      } catch (error) {
        console.error('Erreur de connexion:', error)
        throw new Error('Le courriel ou le mot de passe est invalide.')
      }

    },

    async rafraichirJeton() {
      try {
        const responseJeton = await ApiService.post<{
          token: string;
          refresh_token: string
        }>('/auth/jeton/rafraichir', {
          refresh_token: this.refreshToken
        })

        JwtService.saveToken(responseJeton.data.token, responseJeton.data.refresh_token)
        this.authToken = responseJeton.data.token
        this.refreshToken = responseJeton.data.refresh_token

      } catch (error) {
        console.error('Erreur lors du rafraîchissement du jeton:', error)
        throw error
      }
    },


    async deconnecter(params: { invaliderJeton: boolean }) {
      if (params.invaliderJeton) {
        await ApiService.post('/auth/jeton/invalider', {
          refresh_token: this.refreshToken
        }).catch(error => {
          console.error('Erreur lors de l\'invalidation du jeton:', error)
        })
      }

      JwtService.destroyToken()
      this.authToken = null
      this.utilisateur = null
      localStorage.removeItem('utilisateur')
      localStorage.removeItem('impersonation')
    }

  },


  getters: {
    estConnecte() {
      return !!this.authToken
    }
  }
})
